export const ExperimentNames = {
    UseWarmupState: 'specs.events.ui.UseWarmupState',
    EditTicketPDF: 'specs.events.ui.EditTicketPDF',
    PageInstallFlow: 'specs.events.ui.PageInstallFlow',
    PublishedListTips: 'specs.events.PublishedListTips',
    EventsCommunityLink: 'specs.events.ui.EventsCommunityLink',
    EventsCommunityLinkEditor: 'specs.events.ui.EventsCommunityLinkEditor',
    NewBannerLayout: 'specs.events.BMBannerLayout',
    PreloadSeatingSummary: 'specs.events.ui.PreloadSeatingSummary',
    PricingPlansEventsFlexiForm: 'specs.events.ui.PricingPlansEventsFlexiForm',
    NotificationV2: 'specs.events.ui.NotificationV2',
    EventsMembersAreaV2: 'specs.events.ui.EventsMembersAreaV2',
    NewAboutSection: 'specs.events.ui.NewAboutSection',
    HandleMembersAreaSilentInstall: 'specs.events.ui.HandleMembersAreaSilentInstall',
    OrderLinkExpired: 'specs.events.ui.OrderLinkExpired',
    CalendarResponsiveCells: 'specs.events.ui.CalendarResponsiveCells',
    HeadlessPaymentRedirectUrl: 'specs.events.ui.HeadlessPaymentRedirectUrl',
    ScheduleSettingsToStyles: 'specs.events.ui.ScheduleSettingsToStyles',
    UpdatedSettingsWelcome: 'specs.events.ui.UpdatedSettingsWelcome',
    WixStudioDemoEvents: 'specs.events.ui.WixStudioDemoEvents',
    EventDetailsSlots: 'specs.events.ui.EventDetailsSlots',
    TicketPickerRedesign: 'specs.events.ui.TicketPickerRedesign',
    MessagesNewDesign: 'specs.events.ui.MessagesNewDesign',
    RsvpDynamicMessages: 'specs.events.ui.RsvpDynamicMessages',
    RicosBusinessManager: 'specs.events.ui.Ricos',
    DetailsNoRegistration: 'specs.events.ui.DetailsNoRegistration',
    PapyrusThankYouPageFlow: 'specs.events.ui.PapyrusThankYouPageFlow',
    CheckoutTimeLimit: 'specs.events.ui.EditableCheckoutTimeLimit',
};
//# sourceMappingURL=experiments.js.map